import { authFetch } from '../utils/authFetch';
import { baseUrl } from '../utils/requestUrl';

// The backend maps this as `careProviders/positions/{organizationId}` — without
// the org id the request falls through to `careProviders/{id}` and comes back
// as a "care provider not found" error instead of the positions list.
export const fetchAllPositions = async () => {
    const organizationId = JSON.parse(localStorage.getItem('user')).organizations?.find((org)=>org.active === true)?.id;
    const response = await authFetch(`${baseUrl}/careProviders/positions/${organizationId}`);

    return response.json();
};
